<template>
  <span>
    <v-btn icon @click="handleShowForm" v-if="groupedExecutedServices.length > 0">
      Remove
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card v-if="showModal">
        <v-card-title class="headline">Remove case from invoice</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <div v-for="executedService in groupedExecutedServices">
              <v-layout>
                <v-flex xs1 align-self-center>
                  <service-as-badge :service-id="executedService.serviceId"/>
                </v-flex>
                <v-flex xs1 align-self-center>
                  {{executedService.qty}}
                </v-flex>
                <v-flex xs1>
                  <modal-json-view :json-data="executedService"/>
                </v-flex>
              </v-layout>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import _ from 'lodash';
  import {notificationService} from "../../../application";
  import ServiceAsBadge from '../../Ui/mcc/ServiceAsBadge'
  import ModalJsonView from "../../Ui/ModalJsonView";

  function getDefaultFormData() {
    return {}
  }

  export default {
    name: 'detach-logs-to-invoice-form',
    components: {
      ServiceAsBadge,
      ModalJsonView
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      },
      affectedServices: {
        type: Object,
        required: true
      },
      log: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        return this.isValid
      },
      affectedLogIds() {
        return this.affectedServices.list
          .map(it => it.affectedLogRecordIds)
          .reduce((acc, item) => {
            acc.push(...item);
            return acc
          }, [])
      },
      affectedExecutedLogs() {
        return this.log
          .filter(it => {
            let attachedToInvoice = it.metadata && it.metadata.invoiceInfo && it.metadata.invoiceInfo.id === this.invoiceId;
            return _.includes(this.affectedLogIds, it.id) && it.event === 'ChangeExecuted' && attachedToInvoice
          });
      },
      groupedExecutedServices() {
        let services = {};

        for (let logItem of this.affectedExecutedLogs) {
          let service = services[logItem.serviceId];
          if (!service) {
            services[logItem.serviceId] = service = {
              serviceId: logItem.serviceId,
              qty: 0,
              logs: []
            }
          }

          service.qty += logItem.quantityChange;
          service.logs.push(logItem)
        }

        return _.values(services)
      }
    },
    methods: {
      ...mapActions({
        detachLogsToInvoice: 'invoiceDetachLogsToInvoice',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.$refs.form.validate()) {
          return
        }

        let affectedExecutedLogsIds = this.affectedExecutedLogs
          .map(it => it.id);

        const request = {
          invoiceId: this.invoiceId,
          logIds: affectedExecutedLogsIds,
          affectedCaseId: this.log[0].caseId
        };

        this.requestInProgress = true;

        this
          .detachLogsToInvoice(request)
          .then(() => {
            notificationService.info('Operation success');
            this.resetForm();
            this.requestInProgress = false;
            this.showModal = false
          })
          .catch(e => {
            notificationService.error('Operation failed');
            this.requestInProgress = false;
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/DetachLogsToInvoiceForm.vue